import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock } from "lucide-react";
import { useContactInfo, getPrimaryContact, getContactByType } from "../hooks/useContactInfo";

const ContactPreview: React.FC = () => {
  const { data: contactInfo } = useContactInfo();
  
  const address = getPrimaryContact(contactInfo, 'ADDRESS');
  const phone = getPrimaryContact(contactInfo, 'PHONE');
  const hours = getContactByType(contactInfo, 'HOURS');

  return (
    <section className="section-padding bg-lounge-dark relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="w-full h-full" style={{ 
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
        }} />
      </div>
      
      <div className="container-custom relative z-10">
        <h2 className="section-title text-center">Visit Us</h2>
        <p className="section-subtitle text-center max-w-3xl mx-auto">
          We'd love to welcome you to Seven8Nine Hookah Lounge. Find us in the heart of Winnipeg or get in touch to book your visit.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {/* Location */}
          <div className="bg-lounge-charcoal p-6 rounded-lg flex flex-col items-center text-center border border-lounge-gold/20">
            <div className="bg-lounge-gold/10 p-4 rounded-full mb-4">
              <MapPin size={24} className="text-lounge-gold" />
            </div>
            <h3 className="text-xl font-display font-semibold mb-2 text-lounge-gold">Our Location</h3>
            <p className="text-lounge-light/80">{address?.value}</p>
            <Link to="/contact" className="mt-4 text-lounge-gold hover:underline">Get Directions</Link>
          </div>

          {/* Contact */}
          <div className="bg-lounge-charcoal p-6 rounded-lg flex flex-col items-center text-center border border-lounge-gold/20">
            <div className="bg-lounge-gold/10 p-4 rounded-full mb-4">
              <Phone size={24} className="text-lounge-gold" />
            </div>
            <h3 className="text-xl font-display font-semibold mb-2 text-lounge-gold">Contact Us</h3>
            <p className="text-lounge-light/80">{phone?.value}</p>
            <Link to="/contact" className="mt-4 text-lounge-gold hover:underline">Send Message</Link>
          </div>

          {/* Hours */}
          <div className="bg-lounge-charcoal p-6 rounded-lg flex flex-col items-center text-center border border-lounge-gold/20">
            <div className="bg-lounge-gold/10 p-4 rounded-full mb-4">
              <Clock size={24} className="text-lounge-gold" />
            </div>
            <h3 className="text-xl font-display font-semibold mb-2 text-lounge-gold">Opening Hours</h3>
            {hours.map(hour => (
              <p key={hour.id} className="text-lounge-light/80">{hour.label}: {hour.value}</p>
            ))}
            <Link to="/contact" className="mt-4 text-lounge-gold hover:underline">Book a Table</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPreview;
